var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAlpha = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 42,
  height: 42,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#alpha_svg__a)",
  fillRule: "evenodd",
  d: "M6.306 16.673a4.306 4.306 0 0 0 0 8.612h29.388a4.306 4.306 0 0 0 0-8.612H6.306ZM0 20.98a6.306 6.306 0 0 1 6.306-6.306h29.388a6.306 6.306 0 0 1 0 12.612H6.306A6.306 6.306 0 0 1 0 20.98Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#alpha_svg__b)",
  d: "M32.193 24.243h-.83l2.398-6.53h.817l2.398 6.53h-.83l-1.95-5.497h-.052l-1.951 5.497Zm.306-2.55h3.342v.7h-3.342v-.7Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#alpha_svg__c)",
  d: "M24.587 24.243v-6.53h.79v2.908h3.483v-2.908h.79v6.53h-.79v-2.92h-3.482v2.92h-.791Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#alpha_svg__d)",
  d: "M18.21 24.243v-6.53h2.206c.513 0 .931.092 1.257.277.327.183.57.43.727.743.157.312.236.66.236 1.046 0 .385-.079.735-.236 1.049a1.753 1.753 0 0 1-.72.752c-.326.185-.743.278-1.25.278h-1.582v-.702h1.556c.35 0 .632-.06.845-.181.212-.122.366-.285.462-.491a1.64 1.64 0 0 0 .147-.705c0-.262-.05-.495-.147-.702a1.046 1.046 0 0 0-.466-.484c-.214-.12-.5-.18-.854-.18H19v5.83h-.791Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#alpha_svg__e)",
  d: "M12.39 24.243v-6.53h.79v5.83h3.037v.7H12.39Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#alpha_svg__f)",
  d: "M5.885 24.251h-.829l2.398-6.53h.816l2.398 6.53H9.84l-1.951-5.498h-.051l-1.952 5.498Zm.306-2.55h3.342v.7H6.191v-.7Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "alpha_svg__a",
  x1: 0,
  x2: 45,
  y1: 20.979,
  y2: 22.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4298D3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#07D3E0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "alpha_svg__b",
  x1: 31.363,
  x2: 37.383,
  y1: 20.978,
  y2: 21.03,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4298D3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#07D3E0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "alpha_svg__c",
  x1: 24.587,
  x2: 30.018,
  y1: 20.978,
  y2: 21.021,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4298D3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#07D3E0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "alpha_svg__d",
  x1: 18.21,
  x2: 22.957,
  y1: 20.978,
  y2: 21.011,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4298D3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#07D3E0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "alpha_svg__e",
  x1: 12.39,
  x2: 16.495,
  y1: 20.978,
  y2: 21.003,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4298D3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#07D3E0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "alpha_svg__f",
  x1: 5.056,
  x2: 11.076,
  y1: 20.986,
  y2: 21.038,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4298D3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#07D3E0"
})))));
export { SvgAlpha as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZGJlNzJkOGVjNDkzNjgzODY2MTU2ODVhZjNhNDQ2MTQuc3ZnIjs=";